if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, true));
      });
      if (this.dataset.desktopLayout === 'thumbnail_slider' && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      if (event.detail.currentElement == undefined) return;
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, scrollIntoView = true) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if ((!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') && scrollIntoView) {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('[id^="Slide-"]').forEach((element) => {
        element.classList.remove('is-active');
        element.querySelector('button').removeAttribute('aria-current');
      });
      thumbnail.classList.add('is-active');
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = theme.accessibilityStrings.imageAvailable.replace('[index]', position);
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}

// Custom fix: show first JPG on load; unlock setActiveMedia only on real user interaction
(function() {
  var OriginalMediaGallery = customElements.get('media-gallery');
  if (!OriginalMediaGallery) return;

  var userHasSelectedVariant = false;

  var originalSetActiveMedia = OriginalMediaGallery.prototype.setActiveMedia;

  OriginalMediaGallery.prototype.setActiveMedia = function(mediaId, prepend, scrollIntoView) {
    if (!userHasSelectedVariant) return;

    originalSetActiveMedia.call(this, mediaId, prepend, scrollIntoView);

    if (!window.matchMedia('(max-width: 749px)').matches) return;

    var list = this.elements.viewer.slider || this.elements.viewer.querySelector('ul');
    var self = this;

    if (list) {
      requestAnimationFrame(function() {
        list.scrollLeft = 0;
        requestAnimationFrame(function() { list.scrollLeft = 0; });
      });
      setTimeout(function() { list.scrollLeft = 0; }, 100);
      setTimeout(function() { list.scrollLeft = 0; }, 400);
    }

    setTimeout(function() { self._fixMobile(); }, 50);
    setTimeout(function() { self._fixMobile(); }, 350);
  };

  OriginalMediaGallery.prototype._fixMobile = function() {
    var list = this.elements.viewer.slider || this.elements.viewer.querySelector('ul');

    this.elements.viewer.querySelectorAll('[data-media-id]').forEach(function(item) {
      var img = item.querySelector('img');
      if (!img) return;
      var src = img.getAttribute('srcset') || img.getAttribute('src') || '';
      var isJpg = !src.toLowerCase().includes('.png');
      var isActive = item.classList.contains('is-active');

      if (isJpg) {
        item.classList.add('is-jpg');
        item.style.setProperty('display', 'block', 'important');
        item.style.setProperty('pointer-events', 'auto', 'important');

        var w = parseInt(img.getAttribute('width'));
        var h = parseInt(img.getAttribute('height'));
        if (w && h) {
          var ratio = (h / w * 100) + '%';
          item.querySelectorAll('.media--adapt').forEach(function(div) {
            div.style.setProperty('--image-ratio-percent', ratio, 'important');
          });
          if (list) {
            var computedHeight = Math.round(list.offsetWidth * h / w);
            list.style.setProperty('height', computedHeight + 'px', 'important');
          }
        }
      } else {
        item.style.setProperty('display', isActive ? 'block' : 'none', 'important');
        item.style.setProperty('pointer-events', isActive ? 'auto' : 'none', 'important');
      }
    });

    if (this.elements.thumbnails) {
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach(function(thumb) {
        thumb.style.removeProperty('display');
        thumb.style.removeProperty('pointer-events');
        var btn = thumb.querySelector('button');
        if (btn) btn.style.removeProperty('pointer-events');
      });
    }
  };

  // Unlock SOFORT beim ersten Klick - capture phase damit es VOR allem anderen läuft
  document.addEventListener('mousedown', function(e) {
    if (e.target.closest('variant-selects')) {
      userHasSelectedVariant = true;
    }
  }, true);

  document.addEventListener('click', function(e) {
    if (e.target.closest('variant-selects')) {
      userHasSelectedVariant = true;
    }
  }, true);

  document.addEventListener('change', function(e) {
    if (e.target.closest('variant-selects')) {
      userHasSelectedVariant = true;
    }
  }, true);


  var userClickedVariant = false;
  document.addEventListener('click', function(e) {
    if (e.target.closest('variant-selects')) {
      userClickedVariant = true;
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function() {
        if (userClickedVariant) {
          userHasSelectedVariant = true;
        }
      });
    }
  });

  function showFirstJpg() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    var viewer = gallery.elements.viewer;
    var allItems = viewer.querySelectorAll('[data-media-id]');
    var firstJpg = Array.from(allItems).find(function(item) {
      var src = item.querySelector('img')?.getAttribute('src') || item.querySelector('img')?.getAttribute('srcset') || '';
      return !src.toLowerCase().includes('.png');
    }) || allItems[0];

    if (!firstJpg) return;

    allItems.forEach(function(el) { el.classList.remove('is-active'); });
    firstJpg.classList.add('is-active');

    var list = viewer.slider || viewer.querySelector('ul');
    if (list) {
      list.style.scrollBehavior = 'auto';
      list.scrollLeft = 0;
      setTimeout(function() { list.scrollLeft = 0; }, 50);
      setTimeout(function() { list.scrollLeft = 0; }, 200);
      setTimeout(function() { list.style.scrollBehavior = ''; }, 300);
    }

    if (gallery.elements.thumbnails) {
      var firstJpgId = firstJpg.dataset.mediaId;
      gallery.elements.thumbnails.querySelectorAll('[data-target]').forEach(function(thumb) {
        thumb.classList.remove('is-active');
        var btn = thumb.querySelector('button');
        if (btn) btn.removeAttribute('aria-current');
      });
      var firstThumb = gallery.elements.thumbnails.querySelector('[data-target="' + firstJpgId + '"]');
      if (firstThumb) {
        firstThumb.classList.add('is-active');
        var firstBtn = firstThumb.querySelector('button');
        if (firstBtn) firstBtn.setAttribute('aria-current', true);
      }
    }

    if (window.matchMedia('(max-width: 749px)').matches) {
      setTimeout(function() { gallery._fixMobile(); }, 300);
      setTimeout(function() { gallery._fixMobile(); }, 700);
    }
  }

   window.addEventListener('load', function() {
    showFirstJpg();
    setTimeout(function() {
      if (!userHasSelectedVariant) showFirstJpg();
    }, 500);
    setTimeout(function() {
      if (!userHasSelectedVariant) showFirstJpg();
    }, 1000);
    setTimeout(function() {
      if (!userHasSelectedVariant) showFirstJpg();
    }, 1500);
  });


})();
